import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconNoCheck.module.css';

const IconNoCheck = props => {
  const { rootClassName, className, filled } = props;
  const classes = classNames(rootClassName || css.root, className);

  return filled ? (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px">
      <path
        d="M12 2C6.486 2 2 6.486 2 12c.001 5.515 4.487 10.001 10 10.001 5.514 0 10-4.486 10.001-10.001 0-5.514-4.486-10-10.001-10zm0 18.001c-4.41 0-7.999-3.589-8-8.001 0-4.411 3.589-8 8-8 4.412 0 8.001 3.589 8.001 8-.001 4.412-3.59 8.001-8.001 8.001z"></path>
    </svg>
  ) : (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px">
      <path
        d="M12 2C6.486 2 2 6.486 2 12c.001 5.515 4.487 10.001 10 10.001 5.514 0 10-4.486 10.001-10.001 0-5.514-4.486-10-10.001-10zm0 18.001c-4.41 0-7.999-3.589-8-8.001 0-4.411 3.589-8 8-8 4.412 0 8.001 3.589 8.001 8-.001 4.412-3.59 8.001-8.001 8.001z"></path>
    </svg>
  );
};

IconNoCheck.defaultProps = {
  rootClassName: null,
  className: null,
};

IconNoCheck.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconNoCheck;
